import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../DatePickerTheme.css';

const SelectSingleDate = ({ fetchReports, title, theme }) => {
    const [selectedDate, setSelectedDate] = useState(null);
    const [error, setError] = useState('');
    const containerRef = React.useRef(null);
    const handleSubmit = () => {
        if (!selectedDate) {
            setError('Please select a date.');
            return;
        }
        setError('');
        
        const dateData = {
            date: selectedDate.toISOString().split('T')[0]
        };
        
        fetchReports(dateData);
    };

    // Theme-based styling
    const isLightTheme = theme === 'light';
    const inputStyle = {
        padding: '5px',
        textAlign: 'center',
        backgroundColor: isLightTheme ? '#fff' : '#333',
        color: isLightTheme ? '#333' : '#fff',
        border: isLightTheme ? '1px solid #ccc' : '1px solid #555',
    };

    const dateInputStyle = {
        ...inputStyle,
        width: '100%',
        borderRadius: '3px',
        position: 'relative', // Ensure proper positioning for date picker modal
        zIndex: 1000, // Ensure date picker appears above other elements
    };

    const dateInputContainerStyle = {
        flex: 1,
        position: 'relative', // Create positioning context for date picker
        zIndex: 'auto', // Allow proper stacking
    };

    return (
        <div ref={containerRef} style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            justifyContent: 'center',
            alignItems: 'center',
            margin: '20px auto',
            padding: '40px',
            width: '100%',
            border: '2px solid',
            borderRadius: '10px',
            minHeight: '290px',
            position: 'relative',
        }}>

            <h2>{title}</h2>

            {/* Single Date Selection */}
            <div style={{ display: 'flex', flexDirection: 'column', padding: '8px' }}>
                <div style={{ flex: 1 }}>
                    <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: 'bold' }}>
                        Select Date:
                    </label>
                    <div style={dateInputContainerStyle}>
                        <DatePicker
                            selected={selectedDate}
                            onChange={(date) => setSelectedDate(date)}
                            maxDate={new Date()} // Prevent future dates
                            placeholderText="Select Date"
                            dateFormat="dd/MM/yyyy"
                            customInput={<input style={dateInputStyle} />}
                            popperPlacement="bottom-start"
                            showPopperArrow={false}
                            calendarClassName={isLightTheme ? 'light-theme' : 'dark-theme'}
                        />
                    </div>
                </div>
            </div>

            {/* Submit button */}
            <button
                className="hoverable"
                onClick={handleSubmit}
                style={{
                    padding: '5px 10px',
                    width: '100%',
                    backgroundColor: '#007bff',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                }}
            >
                Submit
            </button>

            {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
        </div>
    );
};

export default SelectSingleDate;